<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
      <v-spacer/>
      <div class="mx-3">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              fab
              color="primary"
              small
              :href="exportRoute"
            >
              <v-icon small color="white">
                mdi-application-export
              </v-icon>
            </v-btn>
          </template>
          <span>Exportar</span>
        </v-tooltip>
      </div>
    </div>

    <v-flex xs12>
      <v-data-table
        :loading-text="table.title"
        :server-items-length="table.total"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        :options="table.options"
        :footer-props="{
          'items-per-page-options': [500]
        }"
        sort-by="updatedAt"
        group-by="product"
        @update:options="updateTable"
        class="elevation-1 fixed-header">
        <template v-slot:top>
          <div class="px-3 filters">
            <v-row>
              <v-col md="3">
                <div class="d-flex align-end">
                  <span class="mr-3">
                    Filtros:
                  </span>
                  <v-select
                    v-model="restaurantSelected"
                    :items="restaurants"
                    item-value="id"
                    item-text="name"
                    label="Restaurante"
                    clearable
                    hide-details
                    return-object
                    dense
                    @change="filterByRestaurant"
                    @click:clear="filterByRestaurant"
                  />
                </div>
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:group.header="{ group, items }" cols="4">
          <td colspan="2" class="primary white--text">
            {{ group }}
          </td>
          <td colspan="2" class="primary white--text">
            Total de Orden: {{ calculateTotal(items) }}
          </td>
        </template>
      </v-data-table>
    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </v-layout>
</template>

<script>
import OrderProductsList from '@/models/collections/OrderProductsList'

export default {
  name: 'ShoppingList',
  data () {
    let productsList = new OrderProductsList()

    return {
      status: 'sent',
      productsList,
      datePicker: false,
      dates: [],
      section: 'Orden global para almacen',
      overlay: false,
      dialog: false,
      restaurantSelected: '',
      search: '',
      order: {},
      table: {
        title: 'Cargando productos...',
        loading: true,
        data: [],
        total: 0,
        headers: [
          { text: 'Restaurante', value: 'restaurant' },
          { text: 'Area', value: 'area.name', sortable: false },
          { text: 'Cantidad', value: 'quantity', sortable: false },
          { text: 'Unidad', value: 'unit.name', sortable: false }
        ],
        options: {
          itemsPerPage: 500,
          page: 1
        }
      }
    }
  },
  computed: {
    exportRoute () {
      return `${process.env.VUE_APP_API_URL}/v1/shopping/export?restaurant=${this.$store.state.currentRestaurant.data._id}&status=${this.status}&provider=${this.$store.state.currentProvider.data._id}`
    },
    restaurants () {
      return this.$store.state.currentProvider.restaurants.data
    }
  },
  methods: {
    updateOrders (order) {
      const index = this.productsList.models.findIndex(mod => mod.id === order.id)
      this.productsList.models[index] = order
      this.productsList.replace(this.productsList.models)
      this.table.data = this.ordersWithTimeAgo()
    },
    updateTable: async function (data) {
      const { sortBy, sortDesc } = data
      if (sortBy[0] === 'updatedAt') {
        sortDesc[0] = true
      }
      await this.load({
        limit: data.itemsPerPage,
        skip: (data.itemsPerPage * (data.page - 1)),
        sort: `${sortDesc[0] ? '-' : ''}${sortBy[0]}`,
        status: this.status
      })
    },
    async load (params = null) {
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        sort: '-updatedAt'
      }
      try {
        const { response } = await this.productsList.fetch({ params })
        this.table.data = this.productsList.models
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    async filterByRestaurant (restaurant) {
      this.restaurantSelected = restaurant.id
      const params = {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        sort: '-updatedAt',
        restaurant: this.restaurantSelected
      }
      await this.load(params)
    },
    calculateTotal (items) {
      return items.reduce((acc, item) => acc + item.quantity, 0)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
